module.exports = __webpack_public_path__ + "static/media/noImageM.170f33ac.jpg";